import React from 'react';
import _ from 'underscore';

import {BulkAssemblyMethod, FragmentProductionMethod} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {FragmentProductionMethodDropdown} from 'molbio/bulk-assembly/setup-modal/controls/FragmentProductionMethodDropdown';

interface GibsonBinControlsProps {
  fragmentProductionMethod: FragmentProductionMethod;
  onChangeFragmentProductionMethod: (newFragmentProductionMethod: FragmentProductionMethod) => void;
  isReadOnly: boolean;
}

export function GibsonBinControls(props: GibsonBinControlsProps): JSX.Element {
  return (
    <FragmentProductionMethodDropdown
      fragmentProductionMethod={props.fragmentProductionMethod}
      updateFragmentProductionMethod={props.onChangeFragmentProductionMethod}
      dropdownMethods={_.compact([
        FragmentProductionMethod.PRIMER_PAIR,
        FragmentProductionMethod.EXISTING_HOMOLOGY_REGIONS,
        FragmentProductionMethod.EXISTING_CUT_SITES,
      ])}
      bulkAssemblyMethod={BulkAssemblyMethod.GIBSON}
      hideLabels={true}
      disabled={props.isReadOnly}
    />
  );
}
